var path = '/client/common/modules/fab/views/fab-actions.html';
var html = "<div class=\"fab__actions fab__actions--{{ parentCtrl.direction }}\" ng-transclude></div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;